import React from 'react';

const WorkOrdersDoc = (
  <>
    This is an algorithm that attempts to fill orders at the best price.
    <br></br>
    <b>parameters:</b>
    <br></br>
    <b>work order limit:</b>
    <br></br>
    When to give in with working the order. If opening a position, will cancel
    the order and terminate the system.
    <br></br>
    If closing a position, will place the order at current bid/ask price (as
    opposed to the next phase of working the order).
    <br></br>Let's say the first ask we recieve is at 1$, and you set this value
    at 10%.
    <br></br>
    Once the ask exceeds 1.1, it will cancel the remainder of the order if
    opening a position. If closing, it will place the order
    <br></br>
    at whatever the price we received was.
    <br></br>
    <b>pct btwn bid ask:</b>
    <br></br>
    The starting pct between bid and ask to begin working the order.
    <br></br>
    Ex: if bid is 99.5, ask is 100, percentBetweenBidAsk is .6. If buying, the
    first order will be placed at 99.8.
    <br></br>
    If selling, the first order will be placed at 99.7.
    <br></br>
    <b>pct increase per order attempt:</b>
    <br></br>How much to increase the pct for each order modification.
    <br></br>
    Ex: if bid is 99.5, ask is 100, percentBetweenBidAsk is .6. If buying, the
    first order will be placed at 99.8.
    <br></br>
    We next get a quote of bid 99.8 ask 100. Let's say
    percentIncreaseBetweenBidAsk is .1.
    <br></br>
    our next attempt at percentBetweenBidAsk will be .7. Our next order will be
    placed at 99.94.
    <br></br>
    <br></br>
    <p>
      How to sit on the bid/mid/ask: If pct increase per order attempt is set to
      0, your order will always remain at the value chosen for "pct btwn bid
      ask". You can use this feature to sit on the bid, mid, or ask. If you set
      pct increase per order attempt to 50%, your order will be modified to be
      the midpoint of every incoming quote. If you set it to 0, it will be the
      bid of every quote if long, or the ask of every quote if short.
    </p>
  </>
);
//"This is an algorithm that attempts to fill orders at the best price. \n" +
//"parameters:\n" +
//"getAwayOffsetPct:\n" +
//"     When to give in with working the order. If opening a position, will cancel the order and terminate the system.\n" +
//"     If closing a position, will place the order at current bid/ask price.\n" +
//"percentBetweenBidAsk:\n" +
//"percentIncreaseBetweenBidAsk:\n" +
//"";
export default WorkOrdersDoc;
